
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#4ac692","data-name":"ic_available hours","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 1846","d":"M8 0a8 8 0 11-8 8 8 8 0 018-8z","fill":"inherit"}}),_c('path',{attrs:{"data-name":"Path 1845","d":"M4.14 8.224l3.089 2.155 4.633-5.3","fill":"none","stroke":"#2e2c34","stroke-linecap":"round","stroke-width":"2"}})])
          )
        }
      }
    